import { createStore } from 'vuex';
import i18n from '../i18n';

let storeLoadedResolve;

const store = createStore({
    state: {
        layout: '',
        is_show_sidebar: true,
        is_show_search: false,
        is_dark_mode: false,
        dark_mode: 'light',
        locale: null,
        menu_style: 'vertical',
        layout_style: 'full',
        countryList: [
            { code: 'zh', name: 'Chinese' },
            { code: 'da', name: 'Danish' },
            { code: 'en', name: 'English' },
            { code: 'fr', name: 'French' },
            { code: 'de', name: 'German' },
            { code: 'el', name: 'Greek' },
            { code: 'hu', name: 'Hungarian' },
            { code: 'it', name: 'Italian' },
            { code: 'ja', name: 'Japanese' },
            { code: 'pl', name: 'Polish' },
            { code: 'pt', name: 'Portuguese' },
            { code: 'ru', name: 'Russian' },
            { code: 'es', name: 'Spanish' },
            { code: 'sv', name: 'Swedish' },
            { code: 'tr', name: 'Turkish' },
        ],
        userLogado: false,
        telaTrancada: false,
        buscaFavorito: false,
        userDadosLoaded: false,
        // Multi-CNPJ: empresa filha selecionada no menu superior; null = opera como o titular
        empresaAtiva: null,
        syncDados: {},
        configs: [],
        configsAl: [],
        userDados: {
            id: 0,
            nome: "John Doe",
            email: "email@email.com",
            razaosocial: "",
            cnpj: "",
            token: "",
            senha: "",
            licencas: [] // Garanta que 'licencas' exista, mesmo que seja um array vazio
        },
        buscaDados: {
            dataspub: '',
            mpls: {
                pls: '',
                id: 0,
                nome: '',
            },
            tpdata: 'd',
            tpfiltro: '',
            opcObj: "1",
            portais: [],
        },
        pregaoDados: {
            pregao: {},
            itens: [],
        },
    },
    mutations: {
        setLayout(state, payload) {
            state.layout = payload;
        },
        toggleSideBar(state, value) {
            state.is_show_sidebar = value;
        },
        toggleSearch(state, value) {
            state.is_show_search = value;
        },
        toggleLocale(state, value) {
            value = value || 'en';
            i18n.global.locale = value;
            localStorage.setItem('i18n_locale', value);
            state.locale = value;
        },
        toggleDarkMode(state, value) {
            //light|dark|system
            value = value || 'light';
            localStorage.setItem('dark_mode', value);
            state.dark_mode = value;
            if (value == 'light') {
                state.is_dark_mode = false;
            } else if (value == 'dark') {
                state.is_dark_mode = true;
            } else if (value == 'system') {
                if (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
                    state.is_dark_mode = true;
                } else {
                    state.is_dark_mode = false;
                }
            }

            if (state.is_dark_mode) {
                document.querySelector('body').classList.add('dark');
            } else {
                document.querySelector('body').classList.remove('dark');
            }
        },
        toggleMenuStyle(state, value) {
            //horizontal|vertical|collapsible-vertical
            value = value || '';
            localStorage.setItem('menu_style', value);
            state.menu_style = value;
            if (!value || value === 'vertical') {
                state.is_show_sidebar = true;
            } else if (value === 'collapsible-vertical') {
                state.is_show_sidebar = false;
            }
        },
        toggleLayoutStyle(state, value) {
            //boxed-layout|large-boxed-layout|full
            value = value || '';
            localStorage.setItem('layout_style', value);
            state.layout_style = value;
        },

        //######## MEUS ##########################################################################################################################################
        changeConfigs(state, newConfigs) {
            state.configs = newConfigs;
            localStorage.setItem('configs', JSON.stringify(newConfigs));
        },
        changeConfigsAl(state, newConfigs) {
            state.configsAl = newConfigs;
            localStorage.setItem('configsAl', JSON.stringify(newConfigs));
        },
        changeUserDados(state, newUserDados) {
            state.userDados = newUserDados;
            localStorage.setItem('userDados', JSON.stringify(newUserDados));
        },
        changeUserLogado(state, bVal) {
            state.userLogado = bVal;
            localStorage.setItem('userLogado', bVal);
        },
        changeTelaTrancada(state, bVal) {
            state.telaTrancada = bVal;
            localStorage.setItem('telaTrancada', bVal);
        },
        changeBuscaDados(state, value) {
            state.buscaDados = value;
            localStorage.setItem('buscaDados', JSON.stringify(value));
        },
        changeBuscaFavorito(state, value) {
            state.buscaFavorito = value;
        },
        changePregaoRegDados(state, value) {
            state.pregaoDados.pregao = value;
        },
        changePregaoItensDados(state, value) {
            state.pregaoDados.itens = value;
        },
        changeSyncDados(state, value) {
            state.syncDados = value;
        },
        setUserDadosLoaded(state, value) {
            state.userDadosLoaded = value;
        },
        // Mutações para atualizar as licenças
        setUserLicencas(state, licencas) {
            state.userDados.licencas = licencas;
        },
        // Multi-CNPJ: seleciona/limpa a empresa ativa ({cnpj, razaosocial, nomefantasia, lanceweb} ou null)
        setEmpresaAtiva(state, empresa) {
            state.empresaAtiva = empresa || null;
            if (empresa) {
                localStorage.setItem('empresaAtiva', JSON.stringify(empresa));
            } else {
                localStorage.removeItem('empresaAtiva');
            }
        }
    },
    getters: {
        layout(state) {
            return state.layout;
        },

        //######################################### MEUS #############################################
        syncDados(state) {
            return state.syncDados;
        },
        configs(state) {
            return state.configs;
        },
        configsAl(state) {
            return state.configsAl;
        },
        userDadosLoaded: (state) => state.userDadosLoaded,
        userDados(state) {
            return state.userDados;
        },
        userLogado(state) {
            return state.userLogado;
        },
        telaTrancada(state) {
            return state.telaTrancada;
        },
        buscaDados(state) {
            return state.buscaDados;
        },
        pregaoRegDados(state) {
            return state.pregaoDados.pregao;
        },
        pregaoItensDados(state) {
            return state.pregaoDados.itens;
        },
        userLics(state) {
            return state.userDados.licencas;
        },
        lanceweb(state) {
            // Com empresa filha ativa, vale a liberação de lances dela
            if (state.empresaAtiva) return Number(state.empresaAtiva.lanceweb) === 1;
            return Number(state.userDados?.lanceweb) === 1;
        },
        // Multi-CNPJ
        empresaAtiva(state) {
            return state.empresaAtiva;
        },
        cnpjAtivo(state) {
            return state.empresaAtiva?.cnpj || state.userDados?.cnpj || '';
        },
        razaoSocialAtiva(state) {
            return state.empresaAtiva?.razaosocial || state.userDados?.razaosocial || '';
        },
        buscaFavorito(state) {
            return state.buscaFavorito;
        },

    },
    actions: {},
    modules: {},
});

store.loaded = new Promise(resolve => {
    storeLoadedResolve = resolve;
});

export { storeLoadedResolve }; // Exporta o resolve para usar no router
export default store;
